type CardSubtitleOptions = {
  text: string;
};

const CardSubtitle = ({ text }: CardSubtitleOptions) => (
  <p className="text-sm card-subtitle">{text}</p>
);

export default CardSubtitle;
